import * as tslib_1 from "tslib";
import React from 'react';
export var FloatingLabelWrapper = function FloatingLabelWrapper(_ref) {
  var state = _ref.state,
      className = _ref.className,
      prefix = _ref.prefix,
      disabled = _ref.disabled,
      children = _ref.children,
      style = _ref.style;
  return React.createElement("div", {
    className: "flabel".concat(className ? " ".concat(className) : '').concat(state.isFilled ? ' filled' : '').concat(state.hasFocus ? ' on' : '').concat(disabled ? ' disabled' : ''),
    "data-prefix": prefix,
    style: style
  }, children);
};
export var FloatingLabel = function FloatingLabel(_a) {
  var id = _a.id,
      label = _a.label,
      icon = _a.icon,
      children = _a.children,
      style = _a.style,
      state = _a.state,
      wrapperProps = tslib_1.__rest(_a, ["id", "label", "icon", "children", "style", "state"]);

  return React.createElement(FloatingLabelWrapper, Object.assign({}, wrapperProps, {
    state: state,
    style: style
  }), (!state || !state.isFilled) && React.createElement("label", {
    className: "flabel-title",
    htmlFor: id
  }, label), React.createElement("div", {
    className: "flabel-value"
  }, children), icon && React.createElement("div", {
    className: "flabel-icon"
  }, icon));
};